import React, { Component } from 'react';
import './VerseCard.css';
import Quran from '../../quran/Quran'

class VersCard extends Component {
  
  constructor(props) {
    super(props)

    this.state = {
      isRotated: false
    }

    // if (this.props.isDefaultRotated) {
    //   this.state.isRotated = true
    // }

    this.showVerse = this.showVerse.bind(this)
    this.hideVerse = this.hideVerse.bind(this)
    this.toggleShowVerse = this.toggleShowVerse.bind(this)
  }

  componentDidMount() {
    if (window.currentAya === this.props.globalAya) {
      this.setState({ isRotated: true })
    }
  }

  showVerse() {
    this.setState({isRotated: true})
  }

  hideVerse() {
    this.setState({isRotated: false})
  }

  toggleShowVerse() {
    this.setState(state => ({isRotated: !state.isRotated}))
  }
  
  render() {
    
    console.log(this.props.globalAya)

    const {ayaNumber, suraNumber, suraName} = Quran.getSuraAndAya(this.props.globalAya)
    const verseText = Quran.quranText[this.props.globalAya][0]

    return (
      <div onClick={this.toggleShowVerse}
           className={`verse-card ${this.state.isRotated ? 'verse-card--rotated' : ''}`}
      >
        <div className="verse-card__front">
          <h4 className="verse-card__verse-title">آیه‌ی {ayaNumber}</h4>
          <h3 className="verse-card__sura-title">سوره‌ی {suraName}</h3>
        </div>
        
        <div className="verse-card__back">
          <p className="verse-card__text">{verseText}</p>
          <span className="verse-card__signature">
          {suraName} / {ayaNumber}
          </span>
        </div>

      </div>
    )
  }
}

export default VersCard;



// WEBPACK FOOTER //
// ./src/components/VerseCard/VerseCard.jsx